import * as React from 'react'
import { TRIPS_HISTORY_DETAILS_TABS } from '../../state/constants/index'
import { ITripHistoryObject } from '../../types/index'
import Close from '../icons/ui/Close'
import Modal from '../ui/Modal'
import TripDetailsMap from './TripDetailsMap'
import TripHistoryAuditLog from './TripHistoryAuditLog'
import TripHistoryDetailsTabs from './TripHistoryDetailsTabs'
import TripHistoryDriverDetails from './TripHistoryDriverDetails'
import TripHistoryFeedbackDetails from './TripHistoryFeedbackDetails'
import TripHistoryMetaDetails from './TripHistoryMetaDetails'
import TripHistoryRiderDetails from './TripHistoryRiderDetails'
import TripHistoryTimingDetails from './TripHistoryTimingDetails'
import TripHistoryVehicleDetails from './TripHistoryVehicleDetails'
import TripPickupDropoffWidget from './TripPickupDropoffWidget'
import * as moment from 'moment'

interface ITripsHistoryDetailsModalProps {
  items: any
  isFetching: boolean
  onComponentMount: () => void
  history: any
  match: any
}

interface ITripsHistoryDetailsModalState {
  activeTab: TRIPS_HISTORY_DETAILS_TABS.TRIP_DETAILS | TRIPS_HISTORY_DETAILS_TABS.AUDIT_LOG
}

interface ITripDetailsProps {
  trip: ITripHistoryObject
}

const TripDetails = (props: ITripDetailsProps) => {
  const trip: ITripHistoryObject = props.trip
  return (
    <React.Fragment>
      <TripDetailsMap />
      <div className='mb2'>
        <TripPickupDropoffWidget
          pickup={trip.location ? trip.location.pickUpFullAddress : ''}
          pickupNotes='Notes for pickup'
          dropoff={trip.location ? trip.location.dropOffFullAddress : ''}
          dropoffNotes='Dropoff notes'
        />
      </div>
      <div className='mb2'>
        <TripHistoryMetaDetails trip={trip} />
      </div>
      <div className='mb2'>
        <TripHistoryTimingDetails trip={trip} />
      </div>
    </React.Fragment>
  )
}

class TripsHistoryDetailsModal extends React.Component<ITripsHistoryDetailsModalProps, ITripsHistoryDetailsModalState> {
  constructor(props: any) {
    super(props)

    this.state = {
      activeTab: TRIPS_HISTORY_DETAILS_TABS.TRIP_DETAILS
    }
  }

  public componentWillMount() {
    this.props.onComponentMount()
  }

  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
          <div className='bg-light-grey8 col-6 flex p2 relative'>
            <Close height={15} width={15} className='svg-grey absolute right-1 top-1 z1' onClick={this.onCloseClick} />
            {this.content()}
          </div>
        </div>
      </Modal>
    )
  }

  private onCloseClick = () => {
    this.props.history.goBack()
  }

  private content = (): any => {
    if (this.props.isFetching) {
      return <React.Fragment>Loading</React.Fragment>
    }

    const trip: ITripHistoryObject = this.props.items[this.props.match.params.tripId]

    return (
      <React.Fragment>
        <div className='bg-white col-6 pr2'>{this.tripDetailsContainer(trip)}</div>
        <div className='bg-light-grey8 col-6 pl2 relative'>{this.tripMetaContainer(trip)}</div>
      </React.Fragment>
    )
  }

  private onDetailsTabChange = (
    tab: TRIPS_HISTORY_DETAILS_TABS.TRIP_DETAILS | TRIPS_HISTORY_DETAILS_TABS.AUDIT_LOG
  ) => {
    this.setState({ activeTab: tab })
  }

  private tripDetailsContainer = (trip: ITripHistoryObject): any => {
    if (!trip) {
      return null
    }
    return (
      <React.Fragment>
        <div className='h4 mb2'>{moment(trip.createdAt).format('MMMM DD, YYYY - HH:mm A')}</div>
        <div>
          <div className='mb2'>
            <TripHistoryDriverDetails trip={trip} />
          </div>
          <div className='mb2'>
            <TripHistoryVehicleDetails trip={trip} />
          </div>
          <div className='mb2'>
            <TripHistoryRiderDetails trip={trip} />
          </div>
          <div className='mb2'>
            <TripHistoryFeedbackDetails trip={trip} />
          </div>
        </div>
      </React.Fragment>
    )
  }

  private tripMetaContainer = (trip: ITripHistoryObject): any => (
    <React.Fragment>
      <TripHistoryDetailsTabs activeTab={this.state.activeTab} onTabChange={this.onDetailsTabChange} />
      {this.tripDetailsTabContent(trip)}
    </React.Fragment>
  )

  private tripDetailsTabContent = (trip: ITripHistoryObject): any => {
    switch (this.state.activeTab) {
      case TRIPS_HISTORY_DETAILS_TABS.TRIP_DETAILS: {
        return <TripDetails trip={trip} />
      }
      case TRIPS_HISTORY_DETAILS_TABS.AUDIT_LOG: {
        return this.auditLog(trip)
      }
    }
  }

  private auditLog = (trip: ITripHistoryObject): any => {
    return (
      <div className='mt2'>
        <TripHistoryAuditLog logs={trip.auditLogs} />
      </div>
    )
  }
}

export default TripsHistoryDetailsModal



// WEBPACK FOOTER //
// ./src/components/trips/TripsHistoryDetailsModal.tsx